/**
 * Identity numbers for `each()` cache keys (HS2-D2G57R). A row's cache key must
 * change whenever an object it renders from is replaced, but `each()` compares
 * keys by value, so objects are folded in as a stable per-object number.
 */
const ids = new WeakMap<object, number>();
let next = 1;

/** A number that stays the same for one object and differs between objects; 0 for null/undefined. */
export function refId(value: object | null | undefined): number {
  if (value === null || value === undefined) return 0;
  let id = ids.get(value);
  if (id === undefined) {
    id = next++;
    ids.set(value, id);
  }
  return id;
}
